/*
 * mutations.js
 *
 * Description: Holds global Mutations (for store).
 *
 * This file is part of: "http://apps.sundair.com/", "Sundair-2019"
 * Copyright 2018,2019,2020,2021  Sundair GmbH
 * Contact:  http://www.sundair.com/
 * @author Learek <michael.broeker@sundair.com>
 *
 */
// demo
export const updateValue = (state, payload) => {
    state.value = payload;
};
